module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic1.33af51a8.png";